(() => {
  const sections = document.querySelectorAll(".sas-trusted-brands");
  if (!sections.length) return;

  let lastY = window.pageYOffset || 0;
  let direction = "down";

  const updateDirection = () => {
    const y = window.pageYOffset || 0;
    const next = y > lastY ? "down" : y < lastY ? "up" : direction;
    if (next !== direction) {
      direction = next;
      sections.forEach((section) => {
        section.dataset.scrollDirection = direction;
        section.classList.add("sas-trusted-brands--switching");
        window.setTimeout(() => {
          section.classList.remove("sas-trusted-brands--switching");
        }, 220);
      });
    }
    lastY = y;
  };

  sections.forEach((section) => {
    section.dataset.scrollDirection = direction;
  });

  window.addEventListener("scroll", updateDirection, { passive: true });
})();
